import { render } from "./live-info.vue?vue&type=template&id=50d60250"
import script from "./live-info.vue?vue&type=script&lang=js"
export * from "./live-info.vue?vue&type=script&lang=js"

import "./live-info.vue?vue&type=style&index=0&id=50d60250&lang=scss"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__